webpackJsonp([1],{

/***/ "+Xhc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "confirm-main"
  }, [_c('div', {
    staticClass: "confirm-title"
  }, [_c('h1', {
    staticClass: "confirm-text"
  }, [_vm._v(_vm._s(_vm.title || '确认'))]), _vm._v(" "), _c('i', {
    staticClass: "confirm-cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "confirm-content"
  }, [_vm._v(_vm._s(_vm.content || '是否确定该选择'))]), _vm._v(" "), _c('div', {
    staticClass: "confirm-footer"
  }, [_c('button', {
    staticClass: "confirm-footer-success",
    on: {
      "click": _vm.okFn
    }
  }, [_vm._v(_vm._s(_vm.ok || '确定'))]), _vm._v(" "), _c('button', {
    staticClass: "confirm-footer-default",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.cancel || '取消'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "32bK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "39ur":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    data: function data() {
        return {
            result: undefined
        };
    },

    methods: {
        show: function show() {
            this.result = undefined;
            var _self = this;
            this.$modal.input().then(function (res) {
                _self.result = res;
            }).catch(function (rej) {
                _self.result = rej;
            });
        }
    }
};

/***/ }),

/***/ "5yg7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".confirm-main[data-v-2fc5f921]{width:60%;max-width:600px;margin:50px auto;background-color:#fff;opacity:1;border-radius:5px;-webkit-box-shadow:0 0 25px rgba(0,0,0,.2);box-shadow:0 0 25px rgba(0,0,0,.2);min-width:300px}.confirm-title[data-v-2fc5f921]{height:40px;border-bottom:1px solid #f2f3f5;line-height:40px;padding:0 20px;color:#999;position:relative}.confirm-text[data-v-2fc5f921]{font-weight:300;font-size:16px}.confirm-cancel[data-v-2fc5f921]{font-style:normal;position:absolute;top:0;right:20px;cursor:pointer;font-size:20px;font-weight:300;opacity:.5}.confirm-content[data-v-2fc5f921]{min-height:40px;padding:20px;font-size:14px;color:#333}.confirm-cancel[data-v-2fc5f921]:hover{color:#333}.confirm-footer[data-v-2fc5f921]{padding:10px 20px;border-top:1px solid #f2f3f5}.confirm-footer[data-v-2fc5f921]:after{visibility:hidden;display:block;font-size:0;content:\"\";clear:both;height:0}.confirm-footer button[data-v-2fc5f921]{border:none;color:#fff;min-width:60px;height:30px;border-radius:3px;font-size:13px;cursor:pointer;float:right;margin-left:10px}.confirm-footer button.confirm-footer-success[data-v-2fc5f921]{background-color:#549beb}.confirm-footer button.confirm-footer-success[data-v-2fc5f921]:hover{background-color:#2680e6}.confirm-footer button.confirm-footer-default[data-v-2fc5f921]{background-color:#f7f7f7;color:#333;border:1px solid #ddd}.confirm-footer button.confirm-footer-default[data-v-2fc5f921]:hover{background-color:#dedede;border-color:#bebebe}", ""]);

// exports


/***/ }),

/***/ "CGvp":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("W4TQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c97c04c0", content, true);

/***/ }),

/***/ "Dk48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contain"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.show
    }
  }, [_vm._v("演示")]), _vm._v(" "), _c('p', [_vm._v("\n            结果：" + _vm._s(_vm.result) + "\n        ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("vuejs-modal")]), _vm._v(" "), _c('a', {
    staticClass: "github",
    attrs: {
      "href": "https://github.com/shaodahong/vuejs-modal",
      "target": "_blank"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KTaq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5yg7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4f22a20f", content, true);

/***/ }),

/***/ "LC6L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['title', 'content', 'ok', 'cancel'],
    data: function data() {
        return {
            text: ''
        };
    },

    methods: {
        okFn: function okFn() {
            var _this = this;

            if (!this.text) {
                this.$modal.confirm({
                    title: '提示',
                    content: '内容不能为空'
                }).then(function (res) {}).catch(function (rej) {});
                return;
            }
            this.$modal.confirm().then(function (res) {
                _this.$emit('$ok', _this.$el, _this.text);
            }).catch(function (rej) {});
        },
        cancelFn: function cancelFn() {
            this.$emit('$cancel', this.$el, '你点击了取消');
        }
    }
};

/***/ }),

/***/ "P6mo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__ = __webpack_require__("VYbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc5f921_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__ = __webpack_require__("+Xhc");
function injectStyle (ssrContext) {
  __webpack_require__("KTaq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fc5f921"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc5f921_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VYbP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['title', 'content', 'ok', 'cancel'],
    data: function data() {
        return {};
    },

    methods: {
        okFn: function okFn() {
            this.$emit('$ok', this.$el);
        },
        cancelFn: function cancelFn() {
            this.$emit('$cancel', this.$el);
        }
    }
};

/***/ }),

/***/ "W4TQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".confirm-main[data-v-6dad6c8f]{width:60%;max-width:600px;margin:50px auto;background-color:#fff;opacity:1;border-radius:5px;-webkit-box-shadow:0 0 25px rgba(0,0,0,.2);box-shadow:0 0 25px rgba(0,0,0,.2);min-width:300px}.confirm-title[data-v-6dad6c8f]{height:40px;border-bottom:1px solid #f2f3f5;line-height:40px;padding:0 20px;color:#999;position:relative}.confirm-text[data-v-6dad6c8f]{font-weight:300;font-size:16px}.confirm-cancel[data-v-6dad6c8f]{font-style:normal;position:absolute;top:0;right:20px;cursor:pointer;font-size:20px;font-weight:300;opacity:.5}.confirm-content[data-v-6dad6c8f]{min-height:40px;padding:20px;font-size:14px;color:#333}.confirm-content input[data-v-6dad6c8f]{width:200px;height:25px}.confirm-cancel[data-v-6dad6c8f]:hover{color:#333}.confirm-footer[data-v-6dad6c8f]{padding:10px 20px;border-top:1px solid #f2f3f5}.confirm-footer[data-v-6dad6c8f]:after{visibility:hidden;display:block;font-size:0;content:\"\";clear:both;height:0}.confirm-footer button[data-v-6dad6c8f]{border:none;color:#fff;min-width:60px;height:30px;border-radius:3px;font-size:13px;cursor:pointer;float:right;margin-left:10px}.confirm-footer button.confirm-footer-success[data-v-6dad6c8f]{background-color:#549beb}.confirm-footer button.confirm-footer-success[data-v-6dad6c8f]:hover{background-color:#2680e6}.confirm-footer button.confirm-footer-default[data-v-6dad6c8f]{background-color:#f7f7f7;color:#333;border:1px solid #ddd}.confirm-footer button.confirm-footer-default[data-v-6dad6c8f]:hover{background-color:#dedede;border-color:#bebebe}", ""]);

// exports


/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("39ur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2220e576_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("Dk48");
function injectStyle (ssrContext) {
  __webpack_require__("32bK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2220e576_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kQjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "confirm-main"
  }, [_c('div', {
    staticClass: "confirm-title"
  }, [_c('h1', {
    staticClass: "confirm-text"
  }, [_vm._v(_vm._s(_vm.title || '确认'))]), _vm._v(" "), _c('i', {
    staticClass: "confirm-cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-content"
  }, [_c('label', [_vm._v("\n            请输入："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-footer"
  }, [_c('button', {
    staticClass: "confirm-footer-success",
    on: {
      "click": _vm.okFn
    }
  }, [_vm._v(_vm._s(_vm.ok || '确定'))]), _vm._v(" "), _c('button', {
    staticClass: "confirm-footer-default",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.cancel || '取消'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l+ve":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/**
  * vuejs-modal v0.0.2
  * (c) 2017 shaodahong
  * @license MIT
  */


var _promise = __webpack_require__("erjG");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("vVgV");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("KKZg");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("5ka8");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var es6Promise = createCommonjsModule(function (module, exports) {
  /*!
   * @overview es6-promise - a tiny implementation of Promises/A+.
   * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
   * @license   Licensed under MIT license
   *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
   * @version   4.1.1
   */

  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    'use strict';

    function objectOrFunction(x) {
      var type = typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x);
      return x !== null && (type === 'object' || type === 'function');
    }

    function isFunction(x) {
      return typeof x === 'function';
    }

    var _isArray = undefined;
    if (Array.isArray) {
      _isArray = Array.isArray;
    } else {
      _isArray = function _isArray(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      };
    }

    var isArray = _isArray;

    var len = 0;
    var vertxNext = undefined;
    var customSchedulerFn = undefined;

    var asap = function asap(callback, arg) {
      queue[len] = callback;
      queue[len + 1] = arg;
      len += 2;
      if (len === 2) {
        if (customSchedulerFn) {
          customSchedulerFn(flush);
        } else {
          scheduleFlush();
        }
      }
    };

    function setScheduler(scheduleFn) {
      customSchedulerFn = scheduleFn;
    }

    function setAsap(asapFn) {
      asap = asapFn;
    }

    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

    function useNextTick() {
      return function () {
        return process.nextTick(flush);
      };
    }

    function useVertxTimer() {
      if (typeof vertxNext !== 'undefined') {
        return function () {
          vertxNext(flush);
        };
      }

      return useSetTimeout();
    }

    function useMutationObserver() {
      var iterations = 0;
      var observer = new BrowserMutationObserver(flush);
      var node = document.createTextNode('');
      observer.observe(node, { characterData: true });

      return function () {
        node.data = iterations = ++iterations % 2;
      };
    }

    function useMessageChannel() {
      var channel = new MessageChannel();
      channel.port1.onmessage = flush;
      return function () {
        return channel.port2.postMessage(0);
      };
    }

    function useSetTimeout() {
      var globalSetTimeout = setTimeout;
      return function () {
        return globalSetTimeout(flush, 1);
      };
    }

    var queue = new Array(1000);
    function flush() {
      for (var i = 0; i < len; i += 2) {
        var callback = queue[i];
        var arg = queue[i + 1];

        callback(arg);

        queue[i] = undefined;
        queue[i + 1] = undefined;
      }

      len = 0;
    }

    function attemptVertx() {
      try {
        var r = commonjsRequire;
        var vertx = r('vertx');
        vertxNext = vertx.runOnLoop || vertx.runOnContext;
        return useVertxTimer();
      } catch (e) {
        return useSetTimeout();
      }
    }

    var scheduleFlush = undefined;

    if (isNode) {
      scheduleFlush = useNextTick();
    } else if (BrowserMutationObserver) {
      scheduleFlush = useMutationObserver();
    } else if (isWorker) {
      scheduleFlush = useMessageChannel();
    } else if (browserWindow === undefined && typeof commonjsRequire === 'function') {
      scheduleFlush = attemptVertx();
    } else {
      scheduleFlush = useSetTimeout();
    }

    function then(onFulfillment, onRejection) {
      var _arguments = arguments;

      var parent = this;

      var child = new this.constructor(noop);

      if (child[PROMISE_ID] === undefined) {
        makePromise(child);
      }

      var _state = parent._state;

      if (_state) {
        (function () {
          var callback = _arguments[_state - 1];
          asap(function () {
            return invokeCallback(_state, child, callback, parent._result);
          });
        })();
      } else {
        subscribe(parent, child, onFulfillment, onRejection);
      }

      return child;
    }

    function resolve$1(object) {
      var Constructor = this;

      if (object && (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' && object.constructor === Constructor) {
        return object;
      }

      var promise = new Constructor(noop);
      resolve(promise, object);
      return promise;
    }

    var PROMISE_ID = Math.random().toString(36).substring(16);

    function noop() {}

    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;

    var GET_THEN_ERROR = new ErrorObject();

    function selfFulfillment() {
      return new TypeError("You cannot resolve a promise with itself");
    }

    function cannotReturnOwn() {
      return new TypeError('A promises callback cannot return that same promise.');
    }

    function getThen(promise) {
      try {
        return promise.then;
      } catch (error) {
        GET_THEN_ERROR.error = error;
        return GET_THEN_ERROR;
      }
    }

    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
      try {
        then$$1.call(value, fulfillmentHandler, rejectionHandler);
      } catch (e) {
        return e;
      }
    }

    function handleForeignThenable(promise, thenable, then$$1) {
      asap(function (promise) {
        var sealed = false;
        var error = tryThen(then$$1, thenable, function (value) {
          if (sealed) {
            return;
          }
          sealed = true;
          if (thenable !== value) {
            resolve(promise, value);
          } else {
            fulfill(promise, value);
          }
        }, function (reason) {
          if (sealed) {
            return;
          }
          sealed = true;

          reject(promise, reason);
        }, 'Settle: ' + (promise._label || ' unknown promise'));

        if (!sealed && error) {
          sealed = true;
          reject(promise, error);
        }
      }, promise);
    }

    function handleOwnThenable(promise, thenable) {
      if (thenable._state === FULFILLED) {
        fulfill(promise, thenable._result);
      } else if (thenable._state === REJECTED) {
        reject(promise, thenable._result);
      } else {
        subscribe(thenable, undefined, function (value) {
          return resolve(promise, value);
        }, function (reason) {
          return reject(promise, reason);
        });
      }
    }

    function handleMaybeThenable(promise, maybeThenable, then$$1) {
      if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
        handleOwnThenable(promise, maybeThenable);
      } else {
        if (then$$1 === GET_THEN_ERROR) {
          reject(promise, GET_THEN_ERROR.error);
          GET_THEN_ERROR.error = null;
        } else if (then$$1 === undefined) {
          fulfill(promise, maybeThenable);
        } else if (isFunction(then$$1)) {
          handleForeignThenable(promise, maybeThenable, then$$1);
        } else {
          fulfill(promise, maybeThenable);
        }
      }
    }

    function resolve(promise, value) {
      if (promise === value) {
        reject(promise, selfFulfillment());
      } else if (objectOrFunction(value)) {
        handleMaybeThenable(promise, value, getThen(value));
      } else {
        fulfill(promise, value);
      }
    }

    function publishRejection(promise) {
      if (promise._onerror) {
        promise._onerror(promise._result);
      }

      publish(promise);
    }

    function fulfill(promise, value) {
      if (promise._state !== PENDING) {
        return;
      }

      promise._result = value;
      promise._state = FULFILLED;

      if (promise._subscribers.length !== 0) {
        asap(publish, promise);
      }
    }

    function reject(promise, reason) {
      if (promise._state !== PENDING) {
        return;
      }
      promise._state = REJECTED;
      promise._result = reason;

      asap(publishRejection, promise);
    }

    function subscribe(parent, child, onFulfillment, onRejection) {
      var _subscribers = parent._subscribers;
      var length = _subscribers.length;

      parent._onerror = null;

      _subscribers[length] = child;
      _subscribers[length + FULFILLED] = onFulfillment;
      _subscribers[length + REJECTED] = onRejection;

      if (length === 0 && parent._state) {
        asap(publish, parent);
      }
    }

    function publish(promise) {
      var subscribers = promise._subscribers;
      var settled = promise._state;

      if (subscribers.length === 0) {
        return;
      }

      var child = undefined,
          callback = undefined,
          detail = promise._result;

      for (var i = 0; i < subscribers.length; i += 3) {
        child = subscribers[i];
        callback = subscribers[i + settled];

        if (child) {
          invokeCallback(settled, child, callback, detail);
        } else {
          callback(detail);
        }
      }

      promise._subscribers.length = 0;
    }

    function ErrorObject() {
      this.error = null;
    }

    var TRY_CATCH_ERROR = new ErrorObject();

    function tryCatch(callback, detail) {
      try {
        return callback(detail);
      } catch (e) {
        TRY_CATCH_ERROR.error = e;
        return TRY_CATCH_ERROR;
      }
    }

    function invokeCallback(settled, promise, callback, detail) {
      var hasCallback = isFunction(callback),
          value = undefined,
          error = undefined,
          succeeded = undefined,
          failed = undefined;

      if (hasCallback) {
        value = tryCatch(callback, detail);

        if (value === TRY_CATCH_ERROR) {
          failed = true;
          error = value.error;
          value.error = null;
        } else {
          succeeded = true;
        }

        if (promise === value) {
          reject(promise, cannotReturnOwn());
          return;
        }
      } else {
        value = detail;
        succeeded = true;
      }

      if (promise._state !== PENDING) {} else if (hasCallback && succeeded) {
        resolve(promise, value);
      } else if (failed) {
        reject(promise, error);
      } else if (settled === FULFILLED) {
        fulfill(promise, value);
      } else if (settled === REJECTED) {
        reject(promise, value);
      }
    }

    function initializePromise(promise, resolver) {
      try {
        resolver(function resolvePromise(value) {
          resolve(promise, value);
        }, function rejectPromise(reason) {
          reject(promise, reason);
        });
      } catch (e) {
        reject(promise, e);
      }
    }

    var id = 0;
    function nextId() {
      return id++;
    }

    function makePromise(promise) {
      promise[PROMISE_ID] = id++;
      promise._state = undefined;
      promise._result = undefined;
      promise._subscribers = [];
    }

    function Enumerator$1(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;

        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    function validationError() {
      return new Error('Array Methods must be provided an Array');
    }

    Enumerator$1.prototype._enumerate = function (input) {
      var this$1 = this;

      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this$1._eachEntry(input[i], i);
      }
    };

    Enumerator$1.prototype._eachEntry = function (entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$2) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator$1.prototype._settledAt = function (state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator$1.prototype._willSettleAt = function (promise, i) {
      var enumerator = this;

      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    function all$1(entries) {
      return new Enumerator$1(this, entries).promise;
    }

    function race$1(entries) {
      var Constructor = this;

      if (!isArray(entries)) {
        return new Constructor(function (_, reject) {
          return reject(new TypeError('You must pass an array to race.'));
        });
      } else {
        return new Constructor(function (resolve, reject) {
          var length = entries.length;
          for (var i = 0; i < length; i++) {
            Constructor.resolve(entries[i]).then(resolve, reject);
          }
        });
      }
    }

    function reject$1(reason) {
      var Constructor = this;
      var promise = new Constructor(noop);
      reject(promise, reason);
      return promise;
    }

    function needsResolver() {
      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }

    function needsNew() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }

    function Promise$2(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
      }
    }

    Promise$2.all = all$1;
    Promise$2.race = race$1;
    Promise$2.resolve = resolve$1;
    Promise$2.reject = reject$1;
    Promise$2._setScheduler = setScheduler;
    Promise$2._setAsap = setAsap;
    Promise$2._asap = asap;

    Promise$2.prototype = {
      constructor: Promise$2,

      then: then,

      'catch': function _catch(onRejection) {
        return this.then(null, onRejection);
      }
    };

    function polyfill$1() {
      var local = undefined;

      if (typeof commonjsGlobal !== 'undefined') {
        local = commonjsGlobal;
      } else if (typeof self !== 'undefined') {
        local = self;
      } else {
        try {
          local = Function('return this')();
        } catch (e) {
          throw new Error('polyfill failed because global object is unavailable in this environment');
        }
      }

      var P = local.Promise;

      if (P) {
        var promiseToString = null;
        try {
          promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {}

        if (promiseToString === '[object Promise]' && !P.cast) {
          return;
        }
      }

      local.Promise = Promise$2;
    }

    Promise$2.polyfill = polyfill$1;
    Promise$2.Promise = Promise$2;

    return Promise$2;
  });
});

var auto = es6Promise.polyfill();

if (typeof _assign2.default != 'function') {
  Object.assign = function (target) {
    'use strict';

    var arguments$1 = arguments;

    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments$1[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

es6Promise.polyfill();

var Modal = {
  install: function install(Vue, options) {
    var this$1 = this;

    var defaultOptions = (0, _assign2.default)({
      name: '$modal',
      id: 'modal',
      modals: null,
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000
      }
    }, options);

    this.zIndex = defaultOptions.style.zIndex;

    if (this.isEmpty(defaultOptions.modals)) {
      throw new Error('vuejs-modal plugin have a modals params');
    }

    this.init(defaultOptions.id);

    var modals = Vue.prototype[defaultOptions.name] = {};

    (0, _keys2.default)(defaultOptions.modals).forEach(function (v) {
      modals[v] = function (options) {
        return new _promise2.default(function (resolve, reject) {
          try {
            new Vue({
              render: function render(h) {
                return h(defaultOptions.modals[v], {
                  props: options,
                  style: (0, _assign2.default)(defaultOptions.style, {
                    zIndex: this$1.zIndex
                  }),
                  on: {
                    $ok: function $ok($el, info) {
                      $el.remove();
                      resolve(info);
                    },
                    $cancel: function $cancel($el, info) {
                      $el.remove();
                      reject(info);
                    }
                  }
                });
              }
            }).$mount('#' + defaultOptions.id);
            this$1.zIndex += 5;
            this$1.init(defaultOptions.id);
          } catch (error) {
            console.error('vuejs-modal', error);
          }
        });
      };
    });
  },

  init: function init(name) {
    var div = document.createElement('div');
    div.setAttribute('id', name || 'modal');
    document.getElementsByTagName('body')[0].appendChild(div);
  },
  zIndex: 1000,
  isEmpty: function isEmpty(object) {
    if (object === null || object === undefined) {
      return true;
    }
    for (var i in object) {
      return false;
    }
    return true;
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Modal);
}

var index = Modal;

module.exports = index;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("/5sW");

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__("YkRm");

var _app2 = _interopRequireDefault(_app);

var _vuejsModal = __webpack_require__("l+ve");

var _vuejsModal2 = _interopRequireDefault(_vuejsModal);

var _confirm = __webpack_require__("P6mo");

var _confirm2 = _interopRequireDefault(_confirm);

var _input = __webpack_require__("mep1");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log('confirm', _confirm2.default);

_vue2.default.use(_vuejsModal2.default, {
    modals: {
        confirm: _confirm2.default,
        input: _input2.default
    }
});

var app = new _vue2.default({
    render: function render(h) {
        return h(_app2.default);
    }
}).$mount('#app');

/***/ }),

/***/ "mep1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__("LC6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dad6c8f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("kQjP");
function injectStyle (ssrContext) {
  __webpack_require__("CGvp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dad6c8f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dad6c8f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// static/js/index.c224b355202b88e3bdd4.js